// Module
var code = "<template>\n    <require from=\"./../service/service-list\"></require>\n    <service-list \n        context.bind=\"context\" \n        header-text-key=\"reports.servicedeliveryreportheader\"\n        show-active-filters.bind=\"true\"\n        show-new-button.bind=\"false\"\n        readonly.bind=\"true\"></service-list>\n</template> \n";
// Exports
export default code;